import { Box, Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";
import SectionHeader from "../../../util/component/SectionHeader";
import { Link, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useRouteMatch } from "../utils/RouteMatch";
import Reports from "./royalties/sections/Reports";
import Printouts from "./royalties/sections/Printouts";
import ReportPreview from "./royalties/sections/ReportPreview";
import { useHasScope } from "../../../config/globalConfig";
import { VIEW_PRINTOUTS_HISTORY, VIEW_ROYALTIES_REPORTS } from "../utils/FinanceScope";
import { useRecoilState } from "recoil";
import { STATE_DISABLE_TAB } from "./royalties/constants/RoyaltiesRecoil";

const PageRoyalties = () => {
    const { t } = useTranslation('finance', { keyPrefix: 'royalties' });
    const navigate = useNavigate();
    const location = useLocation();
    const hasScope = useHasScope;
    let ROUTING = [{ id: 2, name: t('tabs.printout-wizard'), pathname: '/finance/royalties/printouts-wizard', visible: false }]
    const [disableTab, setDisableTab] = useRecoilState(STATE_DISABLE_TAB);

    if (hasScope(VIEW_ROYALTIES_REPORTS) && hasScope(VIEW_PRINTOUTS_HISTORY)) {
        ROUTING = [
            { id: 0, name: t('tabs.report'), pathname: '/finance/royalties/', visible: true },
            { id: 1, name: t('tabs.printout'), pathname: '/finance/royalties/printouts', visible: true },
            { id: 2, name: t('tabs.printout-wizard'), pathname: '/finance/royalties/printouts-wizard', visible: false }
        ];
    } else if (hasScope(VIEW_ROYALTIES_REPORTS) ){
        ROUTING = [
            { id: 0, name: t('tabs.report'), pathname: '/finance/royalties/', visible: true },
        ];
    } else if (hasScope(VIEW_PRINTOUTS_HISTORY) ){
        ROUTING = [
            { id: 0, name: t('tabs.printout'), pathname: '/finance/royalties/printouts', visible: true },
            { id: 1, name: t('tabs.printout-wizard'), pathname: '/finance/royalties/printouts-wizard', visible: false }
        ];
    }

    const routeMatch = useRouteMatch(ROUTING.map(it => it.pathname));
    const currentTab = routeMatch?.pattern?.path;

    useEffect(() => {
        if (location.pathname === "/finance/royalties/report") {
            navigate("/finance/royalties");
        }
    })

    return (
        <Box>
            <SectionHeader title={t('header.title')} subtitle={t('header.subtitle')} />
            {!disableTab &&
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={currentTab ? currentTab : false}>
                    {ROUTING.filter(it => it.visible).map(it => <Tab key={it.id} label={it.name} value={it.pathname} to={it.pathname} component={Link} />)}
                </Tabs>
            </Box>
            }
            <Routes>
                {hasScope(VIEW_ROYALTIES_REPORTS) && <Route path="/" element={<Reports />} />}
                {hasScope(VIEW_ROYALTIES_REPORTS) &&<Route path="/report/:id" element={<ReportPreview />} />}
                {hasScope(VIEW_PRINTOUTS_HISTORY) &&<Route path="/printouts" element={<Printouts />} />}
            </Routes>
        </Box>
    );
}

export default PageRoyalties;